import { Module } from "@/services/module";

class InstalledAppList extends Module {
  constructor() {
    super([]);
  }
}

export default new InstalledAppList();
